import React from 'react'
import {
  TextArea,
  Form,
  Button,
  Message,
  Icon,
  Modal,
  Select,
  Image,
  Label,
  Grid,
  Dropdown
} from 'semantic-ui-react'
import ReactDOM from 'react-dom'
import Thumbnail from '../thumbnail/index'
import {createAPIClient, createAWSClient} from '../../../../../services/api'
import {connect} from 'react-redux'
import CreatableSelect from 'react-select/creatable'
import DatePicker from 'react-datepicker'
import moment from 'moment'

const {Field} = Form
const modalStyle = {marginTop: '0px !important', marginLeft: 'auto', marginRight: 'auto'}

function buildFormStateFromIssue (issue) {
  const customFieldValues = {}
  if (issue && issue.custom_field_values) {
    for (let i = 0; i < issue.custom_field_values.length; i++) {
      const cfv = issue.custom_field_values[i]
      const fieldId = cfv.custom_field && (cfv.custom_field._id || cfv.custom_field)
      if (fieldId) {
        customFieldValues[fieldId] = {
          value: cfv.value,
          custom_field: String(fieldId)
        }
      }
    }
  }
  return {
    title: issue && issue.title ? issue.title : '',
    description: issue && issue.description ? issue.description : '',
    label: issue && issue.label && (issue.label._id || issue.label),
    custom_field_values: customFieldValues,
    attachments: issue && issue.attachments ? issue.attachments.slice() : []
  }
}

class EditRepeatRuleIssueModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      issue: buildFormStateFromIssue(props.rule && props.rule.issue),
      imageUploading: false,
      error: undefined,
      isLoading: false
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.rule !== this.props.rule && this.props.rule) {
      this.setState({
        issue: buildFormStateFromIssue(this.props.rule.issue),
        error: undefined,
        isLoading: false,
        imageUploading: false
      })
    }
  }

  onInputChange (e) {
    const targetName = e.target.name
    const targetValue = e.target.value
    if (targetName === 'title' || targetName === 'description' || targetName === 'label') {
      const issue = Object.assign({}, this.state.issue, {
        [targetName]: targetValue ? targetValue : null
      })
      this.setState({issue})
    } else {
      const issue = Object.assign({}, this.state.issue)
      issue.custom_field_values[targetName] = {value: targetValue, custom_field: targetName}
      this.setState({issue})
    }
  }

  onSelectChange (id, e, {value}) {
    this.onInputChange({target: {name: id, value: value}})
  }

  onSelectChangeEditable (id, e) {
    if (!e) return
    this.onInputChange({target: {name: id, value: e.value}})
  }

  onDateChange (id, date) {
    this.onInputChange({target: {name: id, value: date && date.toISOString()}})
  }

  onLabelChange (e, {value}) {
    this.onInputChange({target: {name: 'label', value: value}})
  }

  onAttachmentChange () {
    var attachmentNode = ReactDOM.findDOMNode(this.refs.attachment)
    var file = attachmentNode.files[0]
    if (file !== undefined) {
      this.uploadFile()
    }
  }

  uploadFile () {
    var attachmentNode = ReactDOM.findDOMNode(this.refs.attachment)
    var file = attachmentNode.files[0]
    const api = createAPIClient()
    const extension = file.name.split('.')[1]
    const fileName = file.name.split('.')[0].replace(/ /g, '') + '_' + (new Date()).getTime() + '.' + extension
    this.setState({imageUploading: true})
    api.get(`/api/private/upload/url-files?filename=${fileName}&type=incident-attachment`)
      .then(result => {
        const url = result.data.response
        const awsClient = createAWSClient()
        return awsClient.put(url, file, {}).then(() => url.split('?')[0])
      })
      .then(saveUrl => {
        const attachments = this.state.issue.attachments.concat({url: saveUrl, key: saveUrl})
        const issue = Object.assign({}, this.state.issue, {attachments})
        this.setState({issue, imageUploading: false})
      })
      .catch(() => {
        this.setState({imageUploading: false})
      })
  }

  removeAttachment (id, key) {
    const attachments = this.state.issue.attachments.filter(item => {
      if (id !== undefined) return item._id !== id
      return item.key !== key
    })
    this.setState({issue: Object.assign({}, this.state.issue, {attachments})})
  }

  onSubmit (e) {
    e.preventDefault()
    const rule = this.props.rule
    if (!rule || !rule.issue) return

    const submitIssue = {
      title: this.state.issue.title,
      description: this.state.issue.description,
      label: this.state.issue.label,
      custom_field_values: [],
      attachments: this.state.issue.attachments,
      location: rule.issue.location,
      template: rule.issue.template
    }

    for (let key in this.state.issue.custom_field_values) {
      const obj = this.state.issue.custom_field_values[key]
      if (obj.value) {
        submitIssue.custom_field_values.push({
          value: obj.value,
          custom_field: obj.custom_field
        })
      }
    }

    this.setState({isLoading: true, error: undefined})
    const api = createAPIClient()
    api.put(`/api/repeatrule/${rule._id}`, {issue: submitIssue})
      .then(() => {
        this.props.onSaved()
      })
      .catch(() => {
        this.setState({isLoading: false, error: 'Failed to update issue template.'})
      })
  }

  render () {
    if (!this.props.rule) return null

    const currentTemplate = this.props.templates.filter(temp => temp.id === this.props.templateId)[0]
    const teamMemberOptions = currentTemplate && currentTemplate.all_users.map(teamMember => ({
      key: teamMember.id,
      value: teamMember.id,
      text: teamMember.first_name + ' ' + teamMember.last_name
    }))
    const labelOptions = [{text: 'Select Label', value: undefined}].concat(this.props.labels.map(label => ({
      key: label.id,
      text: label.name,
      value: label.id,
      label: {color: label.color, empty: true, circular: true}
    })))

    return (
      <Modal open={this.props.open} style={modalStyle} onClose={this.props.onClose}>
        <Modal.Header style={{overflow: 'hidden'}}>
          Edit issue template
          <a href='#'>
            <Image
              onClick={this.props.onClose}
              style={{float: 'right', fontSize: '12px', verticalAlign: 'middle', lineHeight: '12px'}}
              avatar
              src={'/icons/close_432859.svg'}
            />
          </a>
        </Modal.Header>
        <Modal.Content>
          <p style={{color: '#666', marginBottom: '1em'}}>
            Changes apply to future issues created by this repeat rule. Existing issues are not affected.
          </p>
          <Form id='editRepeatRuleIssueForm' onSubmit={this.onSubmit.bind(this)}>
            {this.state.error ? (
              <Message negative>
                <Message.Header>{this.state.error}</Message.Header>
              </Message>
            ) : null}

            {this.props.customFields.map(item => (
              <Field key={item.id}>
                <label>{item.name}{item.required ? '*' : ''}</label>
                {(() => {
                  switch (item.value_type) {
                    case 'Single select (API)':
                      return (
                        <Select
                          placeholder='Select a value'
                          defaultValue={this.state.issue.custom_field_values[item.id] && this.state.issue.custom_field_values[item.id].value}
                          options={[{key: 'empty', value: '', text: 'Select a value'}].concat(item.list_values.map(value => ({
                            key: value, value: value, text: value
                          })))}
                          onChange={this.onSelectChange.bind(this, item.id)}
                        />
                      )
                    case 'Picklist':
                      return (
                        <CreatableSelect
                          isClearable
                          defaultValue={this.state.issue.custom_field_values[item.id] && this.state.issue.custom_field_values[item.id].value
                            ? {value: this.state.issue.custom_field_values[item.id].value, label: this.state.issue.custom_field_values[item.id].value}
                            : null}
                          onChange={this.onSelectChangeEditable.bind(this, item.id)}
                          options={[{value: '', label: 'Select a value'}].concat(item.list_values.map(value => ({
                            value: value, label: value
                          })))}
                        />
                      )
                    case 'TeamMember':
                      return (
                        <Dropdown
                          fluid
                          selection
                          multiple
                          defaultValue={this.state.issue.custom_field_values[item.id] && this.state.issue.custom_field_values[item.id].value}
                          options={teamMemberOptions}
                          onChange={this.onSelectChange.bind(this, item.id)}
                        />
                      )
                    case 'Calendar':
                      return (
                        <DatePicker
                          selected={this.state.issue.custom_field_values[item.id] && moment(this.state.issue.custom_field_values[item.id].value).toDate()}
                          onChange={this.onDateChange.bind(this, item.id)}
                          showTimeInput
                          dateFormat='dd/MM/yyyy h:mm aa'
                        />
                      )
                    default:
                      return (
                        <TextArea
                          rows={1}
                          autoHeight
                          name={item.id}
                          onChange={this.onInputChange.bind(this)}
                          value={this.state.issue.custom_field_values[item.id] && this.state.issue.custom_field_values[item.id].value}
                          required={item.required}
                        />
                      )
                  }
                })()}
              </Field>
            ))}

            <Field>
              <label>Label</label>
              <Dropdown
                placeholder='Select Label'
                fluid
                selection
                value={this.state.issue.label}
                options={labelOptions}
                onChange={this.onLabelChange.bind(this)}
              />
            </Field>

            <h5>Attachment list</h5>
            <Grid columns='5' divided>
              <Grid.Row>
                {this.state.issue.attachments.map(item => (
                  <Grid.Column key={item._id || item.key}>
                    <Thumbnail src={item.url} url={item.url} />
                    <a style={{color: 'red'}} href='#' onClick={this.removeAttachment.bind(this, item._id, item.key)}>
                      <Icon name='close' /><u>Delete </u>
                    </a>
                  </Grid.Column>
                ))}
              </Grid.Row>
            </Grid>
            <br />
            <Label as='label' basic htmlFor='repeatRuleAttachment'>
              <Button
                icon='upload'
                label={{basic: true, content: 'Attach file(s)'}}
                labelPosition='right'
                loading={this.state.imageUploading}
              />
              <input
                hidden
                id='repeatRuleAttachment'
                name='attachment'
                onChange={this.onAttachmentChange.bind(this)}
                type='file'
                ref='attachment'
              />
            </Label>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.props.onClose} type='button'>Cancel</Button>
          <Button primary icon='check' content='Save' type='submit' form='editRepeatRuleIssueForm' loading={this.state.isLoading} />
        </Modal.Actions>
      </Modal>
    )
  }
}

function mapStateToProps (state) {
  return {
    templates: state.templates.templates
  }
}

export default connect(mapStateToProps)(EditRepeatRuleIssueModal)



// WEBPACK FOOTER //
// ./src/pages/issues/overview/components/repeatrulepanel/EditRepeatRuleIssueModal.js